import { useEffect } from 'react';
import { useCookiePreferences } from 'components/CookiePreferences/CookiePreferencesProvider';
import { useCookies } from 'hooks/useCookies';
import { CONSENT_COOKIE_NAME } from './constants';
import type { FC } from 'react';

export const ConsentCookie: FC = () => {
  const cookiePreferences = useCookiePreferences();
  const { setCookie } = useCookies();

  useEffect(() => {
    if (cookiePreferences?.updateConsentCookie) {
      cookiePreferences.setUpdateConsentCookie(false);

      setCookie(
        CONSENT_COOKIE_NAME,
        {
          essential: cookiePreferences?.essential,
          performance: cookiePreferences?.performance,
          advertising: cookiePreferences?.advertising,
          functionality: cookiePreferences?.functionality,
        },
        {
          path: '/',
          domain: '.sharesight.com',
          maxAge: 31536000,
          secure: true,
          sameSite: 'lax',
        }
      );
    }
  }, [cookiePreferences, setCookie, cookiePreferences?.updateConsentCookie]);

  return null;
};
